/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_Filter_ButtonInputs */

const en_admin_user_list_mail_filter_button = /** @type {(inputs: Admin_User_List_Mail_Filter_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email filtered users`)
};

const de_admin_user_list_mail_filter_button = /** @type {(inputs: Admin_User_List_Mail_Filter_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail an Filterauswahl`)
};

/**
* | output |
* | --- |
* | "Email filtered users" |
*
* @param {Admin_User_List_Mail_Filter_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_filter_button = /** @type {((inputs?: Admin_User_List_Mail_Filter_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_Filter_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_filter_button(inputs)
	return en_admin_user_list_mail_filter_button(inputs)
});